<script setup lang="ts">
import type { LastRentersPolicyFragmentFragment } from '~/graphql/mma/generated/graphql';

const props = defineProps<{
  policy: LastRentersPolicyFragmentFragment;
  routeName: string;
  uuid: string;
}>();

const lastPolicyData = computed(() => {
  if (props.policy?.skypad) {
    const lastRentersPolicy = props.policy.skypad;
    return {
      name: lastRentersPolicy.policy_number,
      url: `/${props.uuid}/renters/${lastRentersPolicy.policy_number}`,
      status: lastRentersPolicy.policy_status,
      startDate: lastRentersPolicy.coverage_start_date,
      endDate: lastRentersPolicy.coverage_end_date,
      autoRenew: lastRentersPolicy.isAutoRenew,
    };
  }
  if (props.policy?.kamino) {
    const lastRentersPolicy = props.policy.kamino;
    return {
      name: lastRentersPolicy.policyNumber,
      url: `/${props.uuid}/renters/${lastRentersPolicy.policyNumber}`,
      status: lastRentersPolicy.policy_status,
      startDate: lastRentersPolicy.policy_start_date,
      endDate: lastRentersPolicy.policy_end_date ?? undefined,
      autoRenew: lastRentersPolicy.isAutoRenew,
    };
  }
  return undefined;
});
</script>

<template>
  <MenuPolicyNames
    v-if="lastPolicyData"
    title="Renters policies"
    :links="[lastPolicyData]"
    :icon="['fal', 'house']"
    :is-selected="routeName === 'uuid-renters-policyNumber'"
  >
    <template #link-name="rentersPolicy">
      <UiRentersSummarySmall
        :policy="{
          policyNumber: rentersPolicy.name,
          startDate: rentersPolicy.startDate,
          endDate: rentersPolicy.endDate,
          autoRenew: rentersPolicy.autoRenew,
          status: rentersPolicy.status,
        }"
      />
    </template>
  </MenuPolicyNames>
</template>
